/* Custom tab-style mega menu — tab switching + a11y. No dependencies. */
(function () {
  'use strict';

  function activate(scope, index) {
    var tabs = scope.querySelectorAll('.mega-tabs__item');
    var panes = scope.querySelectorAll('.mega-pane');
    for (var i = 0; i < tabs.length; i++) {
      var on = i === index;
      tabs[i].classList.toggle('is-active', on);
      tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
    }
    for (var j = 0; j < panes.length; j++) {
      panes[j].classList.toggle('is-active', j === index);
    }
  }

  function initPanel(item) {
    var panel = item.querySelector('.mega-panel');
    if (!panel) return;
    var tabs = panel.querySelectorAll('.mega-tabs__item');

    tabs.forEach(function (tab) {
      var index = parseInt(tab.getAttribute('data-mega-tab'), 10) || 0;

      // Hover a tab -> switch pane (the tab's link still navigates on click)
      tab.addEventListener('mouseenter', function () {
        activate(panel, index);
      });

      // Keyboard: focus/Enter switches, arrows move between tabs
      tab.addEventListener('focus', function () {
        activate(panel, index);
      });
      tab.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          var next = e.key === 'ArrowDown' ? index + 1 : index - 1;
          if (next < 0) next = tabs.length - 1;
          if (next >= tabs.length) next = 0;
          tabs[next].focus();
        }
      });
    });

  }

  /* Hover intent. When the bar wraps onto two rows, the panel sits below the
     second row, so the pointer crosses other items on its way down. A short
     close delay keeps the open panel alive during that trip, and a switch
     delay stops items merely passed over from stealing the panel. */
  var CLOSE_DELAY = 300;
  var SWITCH_DELAY = 180;

  var openItem = null;
  var closeTimer = null;
  var switchTimer = null;

  function setOpen(item, on) {
    item.classList.toggle('is-open', on);
    var top = item.querySelector('.mega-nav__top');
    if (top) top.setAttribute('aria-expanded', on ? 'true' : 'false');
  }

  function open(item) {
    clearTimeout(closeTimer);
    clearTimeout(switchTimer);
    if (openItem === item) return;
    if (openItem) setOpen(openItem, false);
    var panel = item.querySelector('.mega-panel');
    if (panel) activate(panel, 0); // reset to first tab each time it opens
    setOpen(item, true);
    openItem = item;
  }

  function close() {
    clearTimeout(switchTimer);
    if (openItem) setOpen(openItem, false);
    openItem = null;
  }

  function initHover(nav) {
    var items = nav.querySelectorAll('.mega-nav__item');

    items.forEach(function (item) {
      var hasPanel = item.classList.contains('mega-nav__item--has-panel');

      item.addEventListener('mouseenter', function () {
        clearTimeout(switchTimer);
        if (!openItem) {
          if (hasPanel) open(item);
        } else if (openItem === item) {
          clearTimeout(closeTimer);
        } else {
          // Another panel is open: only switch if the pointer settles here
          switchTimer = setTimeout(function () {
            if (hasPanel) open(item);
            else close();
          }, SWITCH_DELAY);
        }
      });
    });

    nav.addEventListener('mouseleave', function () {
      clearTimeout(switchTimer);
      closeTimer = setTimeout(close, CLOSE_DELAY);
    });
    nav.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
    });

    // Leaving the open item (e.g. into the gap between rows) starts the close
    // timer; re-entering it or its panel cancels it.
    nav.addEventListener('mouseout', function (e) {
      if (openItem && openItem.contains(e.target) && !openItem.contains(e.relatedTarget)) {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(close, CLOSE_DELAY);
      }
    });

    // JS now owns hover state; CSS :hover stays as the no-JS fallback
    nav.classList.add('is-ready');
  }

  function init() {
    document
      .querySelectorAll('.mega-nav__item--has-panel')
      .forEach(initPanel);
    document.querySelectorAll('.mega-nav').forEach(initHover);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
